import {
  Container,
  Heading,
  Divider,
  VStack,
  Center,
  Text,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { usePublicationById } from "../../hooks/data/publication";
import { LoadingSpinner } from "../../components/loading-spinner";
import { ErrorCard } from "../../components/error-card";
import PDFCard from "../../components/pdf-card";
import Header from "../../components/header";
import NavigationBar from "../../components/navigation-bar";

const PublicationData = () => {
  const { id } = useParams();
  const { publication, isLoading, isError } = usePublicationById(id);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return (
      <Container maxW="container.lg">
        <Center>
          <ErrorCard />
        </Center>
      </Container>
    );
  }
  const filename = publication.publicationtitle + ".pdf";
  const header_image = process.env.PUBLIC_URL + "/images/talos.jpeg";

  return (
    <>
      <Helmet>
        <title>Publication Data</title>
      </Helmet>
      <VStack spacing={0}>
        <NavigationBar />
        <Header backgroundImage={header_image} />
        <Container maxW="container.lg" borderColor="black" borderRadius={2}>
          <Heading as="h3" size="lg">
            {publication.publicationtitle}
          </Heading>
          <Text fontSize="sm" color="gray.500">
            {publication.authors}
          </Text>
          <Divider mb={4} />
          <PDFCard
            pdf_location={new URL(
              publication.location,
              `${process.env.REACT_APP_PDFS_URL}/`
            ).toString()}
            file_name={filename}
          />
        </Container>
      </VStack>
    </>
  );
};

export default PublicationData;
